<template>
  <section class="related_stockes">
    <div class="container">
      <div class="section_title text-start">
        <h4 class="font-weight-bold">{{ $t("studios.anotherStudios") }}</h4>
        <hr style="margin-bottom:32px !important"/>
      </div>
      <div class="" v-if="relatedStudios.length > 0">
        <div style="direction: rtl;" class="slider">
          <carousel v-bind="options">
            <slide class="slide-item" v-for="(list, index) in relatedStudios" :key="index">
              <div class="studio-item mx-3">
                <div class="img">
                  <img class="img-fluid main-img" :src="list.main_image_url" alt="studio"/>
                  <div class="rate" v-if="list.totalRates > 0">
                    <span>{{ list.totalRates }}</span>
                    <img class="img-fluid" src="/img/newMainPage/star.png" alt="star icon">
                  </div>
                </div>
                <div class="_info text-start mt-4">
                  <span class="Name text-start"> {{ list.name }} </span>
                  <div class="d-flex align-items-center gap-5 categories-div">
                    <div class="d-flex align-items-center">
                      <img class="img-fluid" src="/img/newMainPage/location.svg" alt="location icon">
                      &nbsp;&nbsp;<span>{{ list.city_name }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <img class="img-fluid" src="/img/newMainPage/category.svg" alt="category icon">
                      &nbsp;&nbsp;<span>{{ list.category_name }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-row mt-4">
                    <router-link :to="{ name: 'studiosDetails', params: { id: (list.slug ?? list.id) } }">
                      <span class="d-inline-flex align-items-center show-more-link">
                        {{ $t("order-now") }}&nbsp;&nbsp;<i class="mdi mdi-arrow-top-left"></i>
                      </span>
                    </router-link>
                    <span class="price">
                      {{ list.native_rent_price }}
                      <img class="img-fluid" src="/img/newMainPage/sar.svg" alt="sar icon">
                      /
                      {{ list.native_rent_type }}
                    </span>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
      <div v-else>
        <v-row>
          <v-col cols="12" md="3">
            <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["relatedStudios"],
  data() {
    return {
      studios: [],
      options: {
        loop: true,
        margin: 5,
        perPage: 1,
        center: false,
        autoplay: true,
        autoplayTimeout: 3000,
        paginationEnabled: false,
        autoplayHoverPause: true,
        navigationEnabled: false,
        paginationColor: "#555",
        paginationActiveColor: "#9f762b",
        paginationSize: 5,
        rtl: true,
        perPageCustom: [
          [0, 1],
          [768, 2],
          [1332, 3],
        ],
      },
      attrs: {
        class: "mb-2",
        boilerplate: true,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.related_stockes {
  margin: 36px 0 !important;

  .studio-item {
    position: relative;
    background: #FFF;
    border-radius: 20px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
    margin: 10px 0;

    @media(max-width: 1263px) {
      direction: rtl !important
    }

    .img {
      position: relative;

      .main-img {
        width: 100%;
        height: 300px;
        position: relative;
        object-fit: cover;
        border-radius: 30px;
        padding: 24px;
        @media (max-width: 768px) {
          height: 200px;
          border-radius: 24px;
          padding: 16px;
        }
      }
    }

    .fav-icon {
      position: absolute;
      top: 22px;
      right: 32px;
      z-index: 9;

      i {
        font-size: 32px;

        &.active {
          color: #E61B42;
        }
      }
    }

    .rate {
      position: absolute;
      top: 32px;
      left: 32px;
      padding: 4px 8px;
      z-index: 9;
      border-radius: 4px;
      opacity: 0.6;
      background: #000;
      backdrop-filter: blur(30px);
      display: inline-flex;
      align-items: start;
      gap: 5px;

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      span {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }

    ._info {
      padding: 0 20px 20px 20px;

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* number of lines to show */
        color: #8D8D8D;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }

      .Name {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* number of lines to show */
        color: #000;
        font-size: 24px;
        line-height: 32px; /* 140% */
        font-style: normal;
        font-weight: 500;
        margin-bottom: 16px;
      }

      .price {
        color: #333;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: inline-flex;
        align-items: center;
        gap: 5px;

        img {
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }

      .show-more-link {
        border-radius: 8px;
        background: #F4F4F4;
        color: #000;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 26px;
        padding: 12px 32px;
      }

      .show-more-link:hover {
        background: #000;
        color: #fff;
        transition: 300ms ease-in-out;
      }

      @media (max-width: 768px) {
        padding: 0 16px 16px 16px;

        span {
          line-height: 12px; /* fallback */
          max-height: 24px; /* fallback */
          font-size: 10px;
        }

        .Name {
          line-height: 14px; /* fallback */
          max-height: 28px; /* fallback */
          font-size: 12px;
          font-weight: 700;
        }

        .price {
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .show-more-link {
          border-radius: 8px;
          font-size: 14px;
          line-height: 18px;
          padding: 20px 24px;
        }
      }

      .categories-div {
        img {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }

        span {
          color: #5B5B5B;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 26px;
        }

        @media (max-width: 768px) {
          img {
            width: 16px;
            height: 16px;
          }

          span {
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
